import React from "react";
import { Dropdown, MenuProps } from "antd";
import {
  DownOutlined,
  SoundOutlined,
  DeleteOutlined,
  BlockOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import { useThemeContext } from "../../../context/ThemeContext";
import { useAppDispatch } from "../../../redux/utils/Dispatcher";
import {
  enterSelectionMode,
  toggleMessageSelection,
} from "../../../redux/slices/chatSlice";
import "./index.scss";

const MsgActionsMenu = ({
  showchatDeleteModal,
  setReplyingTo,
  message,
  type,
}: {
  showchatDeleteModal: (messageId: string) => void;
  setReplyingTo: any;
  message: any;
  type: string;
}) => {
  const dispatch = useAppDispatch();
  const { theme } = useThemeContext();

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "Reply") {
      setReplyingTo(message);
    } else if (e.key === "delete") {
      showchatDeleteModal(String(message.id));
    } else if (e.key === "copy") {
      navigator.clipboard
        .writeText(message.message)
        .then(() => {
          toast.success("Message copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy message:", err);
          toast.error("Failed to copy message");
        });
    } else if (e.key === "forward") {
      const msgToForward = {
        ...message,
        replyMediaType: null,
        replyMessage: null,
      };
      dispatch(enterSelectionMode());
      dispatch(toggleMessageSelection(msgToForward));
    }
  };
  const hasPoll = message.message && message.mediaType === 0 && message.isPoll;

  const menuItems: MenuProps["items"] = [
    !hasPoll && {
      key: "forward",
      icon: <SoundOutlined style={{ color: "#377DEF" }} />,
      label: "Forward",
    },
    !hasPoll && { type: "divider" },
    {
      key: "Reply",
      icon: <BlockOutlined style={{ color: "red" }} />,
      label: "Reply",
    },
    !hasPoll && { type: "divider" },
    !hasPoll && {
      key: "copy",
      icon: <CopyOutlined style={{ color: "#377DEF" }} />,
      label: "Copy",
    },
    { type: "divider" },
    {
      key: "delete",
      icon: <DeleteOutlined style={{ color: "red" }} />,
      label: "Delete",
      danger: true,
    },
  ].filter(Boolean) as MenuProps["items"];
  return (
    <Dropdown
      overlayClassName="custom-dropdown"
      menu={{ items: menuItems, onClick: handleMenuClick }}
      trigger={["click"]}
    >
      <DownOutlined
        style={{
          color:
            type === "user"
              ? theme === "light"
                ? "white"
                : "black"
              : theme === "light"
                ? "black"
                : "white",
          alignSelf: "end",
        }}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default MsgActionsMenu;
